import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import apiFAQ from '../../api/FAQ';
import FAQcontent from '../../components/FAQ/Content';
import Layout from '../../components/FAQ/Layout';

const FAQ = () => {
  const [banners, setBanners] = useState(null);
  const [faqs, setFaqs] = useState([]);
  useEffect(async () => {
    setBanners(await apiFAQ.getBanners());
  }, []);
  useEffect(async () => {
    setFaqs(await apiFAQ.getContent());
  }, []);
  const output = banners && (
    <>
      <Helmet title="FAQ" />
      <Layout data={banners}>{faqs && <FAQcontent data={faqs} />}</Layout>
    </>
  );
  return output;
};

export default FAQ;
